<div class='TableSearchFilter flex-column flex-sm-row'>
  <div class='TableSearchFilter-input'>
    <input [(ngModel)]='inputValue' [placeholder]='placeholder' type='text' />
    <!--        show X icon if input value is not empty-->
    <span
      (click)='onClearInput()'
      *ngIf='inputValue'
      class='TableSearchFilter-input-clear'
    >
    <fa-icon [icon]='iconClose' [size]="'1x'"></fa-icon>
    </span
    >
  </div>
  <div class='TableSearchFilter-button d-inline-block'>
    <button (click)='onSearch()' [disabled]='disabled'>{{ buttonLabel }}</button>
  </div>
</div>
